<template lang="pug">
#home
  vheader
  mobile-nav
  .entry
    .cover
      .container
        h1 观察员申请
        .observer-tip
          p
            |「前沿社」作为邀请参与制及闭门交流为主的社群，
            br
            | 并不只是个神秘封闭的小圈子，
            br
            | 同样愿意把有价值的思考分享给更多希望持续思考、刷新认知的伙伴。
          p
            | 如果您尚未具备成为会员的资质，
            br
            | 即刻可以加入成为「前沿社观察员」。
        .link
          a(v-bind:href="link" target="_blank")
            | 立即申请
            .triangle-right

    .container.min
      .entry-subhead
        h3 OBSERVER BENEFITS
        h3.cn 观察员权益
      .entry-list
        ul
          li 全年至少6次前沿社「前沿工作坊」现场参与资格，以最效率的方式搞懂前沿技术；
          li 极客公园年度两个重磅活动「奇点创新者峰会Rebuild」、「极客公园创新大会IF」VIP参会资格，以及受邀参加前沿社「夏季会晤」、「冬季会晤」至少8场闭门论坛，与中国最优秀的创业者共同探讨前沿的科技趋势、与全球最权威的专家面对面沟通，价值20000元；
          li 还有机会获得前沿社纯闭门学习交流「近场研究」外卡嘉宾机会，具体参加场次视申请人所处行业领域和当次活动主题而定；
          li 第一时间获取「前沿工作坊」、「近场研究」以及前沿社其他相关活动的精彩内容；
          li 优先有机会参与「前沿社」组织的闭门海外游学团，与优秀企业家一同拓展视野、升级认知。

    .container.min
      .entry-subhead
        h3 CONDITIONS OF ENTRY
        h3.cn 申请条件
      .entry-list.special
        ul
          li <b>申　请：</b>申请人通过在线提交申请、完成付款后，即可享受前沿社观察员权益
          li <b>会员费：</b>9,999元/人/年

      .entry-list.about
        p
          | 通过以下方式可申请成为观察员：
          br
          | 1.找到一位前沿社会员作为您的推荐人
          br
          | 2.在线填写前沿观察员申请表格
          br
          | 3.完成付款流程后，即可开启「前沿社观察员」的交流学习旅程
        p
          | 注：
          br
          | 1.前沿社观察员有效期为一年，有效期为自付款成功之日起至次年的同一时间为止；
          br
          | 2.如未能找到前沿社会员作为推荐人，请在申请表格上详细说明申请理由。
  footer-user
  vfooter
</template>

<script>
import Vheader from '../components/Vheader.vue'
import MobileNav from '../components/mobile/Nav.vue'
import FooterUser from '../components/FooterUser.vue'
import Vfooter from '../components/Vfooter.vue'

export default {
  data() {
    return {
      link: 'http://cn.mikecrm.com/bpvLg71'
    }
  },
  components: {
    Vheader,
    Vfooter,
    FooterUser,
    MobileNav
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'
.observer-tip
  line-height 1.6
  font-size 14px
  text-align center
  p
    margin 1em
@media $media
  .observer-tip
    line-height 1.5
    font-size 14px
</style>



// WEBPACK FOOTER //
// Observer.vue?226d8577